(function () {
    "use strict";

    Directives.CompanySubscriptionPromoCodeDirective =  function CompanySubscriptionPromoCodeDirective() {

        return {
            scope:{
                hideLabel: '='
            },
            templateUrl : 'angular/app/modules/core/features/settings/company/subscription/company_subscription_promo_code_directive_template.html',
            controller : 'CompanySettingsPricingController',
            controllerAs : 'pricingVm',
            bindToController : true
        };
    };
}());